<!--
 * @Descripttion:满赠功能修改
 * @version:1.6.5
 * @Author: Jeson
 * @Date: 2021-08-16 08:54:56
 * @LastEditors: Jerry
 * @LastEditTime: 2022-01-07 09:49:36
-->
<template>
  <div
    :style="{
      backgroundColor: (goodsList || []).length > 0 ? '#FFFFFF' : '#F3F5F7'
    }"
  >
    <iHeader v-if="!isAlwaysBuysCom" />
    <!-- 购物车 -->
    <div
      v-if="goodsList.length || invalidGoods.length"
      :class="{ buycar: true, isAlwaysBuysCom: !!isAlwaysBuysCom }"
    >

      <!-- 按照订单满赠显示 -->
      <BuyCarGiftItem
        v-if="GroupByOrder && choseGiftList(GroupByOrderList)"
        :is-by-order="true"
        :choose-gift-num="GroupByOrderChooseGiftNum"
        :multiple="GroupByOrderMultiple"
        :gift-list="choseGiftList(GroupByOrderList)"
        @choseGift="choseGift"
      />

      <!-- 商品列表 -->
      <!-- table title -->
      <div class="goods-title">
        <div class="name">商品信息</div>
        <div class="price">单价</div>
        <div class="amount">数量</div>
        <div class="total">小计</div>
      </div>
      <!-- goods list -->
      <div class="list-content">
        <template v-for="(item, index) in goodsList">
          <!-- 按照活动组合 -->
          <template v-if="item.Activity">
            <!-- 指定专区提示 -->
            <div :key="item.Activity.Id">
              <van-icon v-if="item.Activity.Type === 2" class="topic-tips">
                <van-icon name="warning-o" color="#0F6EEA" size="16px" />
                <span>指定专区不享受商城订单满减活动！</span>
              </van-icon>
              <div
                v-if="item.Activity"
                class="active-goods-card"
                style="margin-bottom: 16px;"
              >
                <buy-car-topic-active-tag
                  :goods-info="item.GoodsSkus"
                  :active-info="item.Activity"
                  :group-info="item"
                />
                <BuyCarProductItem
                  v-for="goodsItem in item.GoodsSkus"
                  :key="goodsItem.ProductSKUId"
                  :has-margin-top="false"
                  :no-border="true"
                  :item="goodsItem"
                  :is-always-buys-com="isAlwaysBuysCom"
                  :is-zq-activity="true"
                  @itemCheckedChanged="checkedChange"
                  @onStepperChange="onStepperChange"
                />
                <BuyCarGiftItemActivity
                  key="GoodsSkuIds"
                  style="margin-bottom: 16px;"
                  :data-source="item"
                  :background="'#f9fafb'"
                  :is-not-click="true"
                  @syncSubmitActivitysFromActivity="syncSubmitActivitysFromActivity"
                />
              </div>
            </div>
          </template>

          <!-- 普通非活动商品 -->
          <template v-else>
            <div
              v-if="item.Activity && item.Activity.Type === 2"
              :key="index + '1'"
              class="topic-tips"
            >
              <van-icon name="warning-o" color="#0F6EEA" size="16px" />
              <span>指定专区不享受商城订单满减活动！</span>
            </div>
            <div v-for="(mode, index) in ModelList" :key="index">
              <div v-if="mode.Products && mode.Products.length > 0">
                <!-- 多商品标签 -->
                <BuyCarGoodsActiveTagMore
                  v-show="mode.GroupActiveGift.length > 0"
                  :multiple="mode.MultipleMore"
                  :activity-id="mode.ActivityId"
                  :activity-gift-list="ordinaryGoodsPremiumList"
                  :gift-list="mode.GroupActiveGift"
                  style="margin-top: 10px;"
                />
                <ActiveTagNotice
                  v-show="mode.GroupActiveGift.length == 0 && mode.ActivityId"
                  style="margin-top: 16px;"
                  :activity-id="mode.ActivityId"
                  :activity-gift-list="ordinaryGoodsPremiumList"
                />
                <BuyCarProductItem
                  v-for="(goodsItem, index) in item.GoodsSkus"
                  v-if="mode.Products.includes(goodsItem.ProductSKUId)"
                  :key="goodsItem.ProductSKUId"
                  :item="goodsItem"
                  :index="index"
                  :has-margin-top="hasMarginTopChange(goodsItem)"
                  :is-always-buys-com="isAlwaysBuysCom"
                  :activity-gift-list="ordinaryGoodsPremiumList"
                  :is-show-activity="true"
                  :is-zq-activity="mode.isNomal ? true : false"
                  :total-amount="totalAmount"
                  @changeGroupActiveGift="changeGroupActiveGift"
                  @itemCheckedChanged="checkedChange"
                  @checkgifthasSend="checkgifthasSend"
                  @onlySubmitActivitys="onlySubmitActivitys"
                  @canclSubmitActivitys="canclSubmitActivitys"
                  @onStepperChange="onStepperChange"
                />
                <BuyCarGiftItem
                  v-if="mode.GroupActiveGift.length > 0"
                  :key="index"
                  style="margin-bottom: 16px;"
                  :gift-list="mode.GroupActiveGift"
                  :background="'#f9fafb'"
                  :multiple="mode.MultipleMore"
                  :choose-gift-num="mode.ChooseGiftNum"
                  :activity-id="mode.ActivityId"
                  :is-not-click="true"
                  @choseGift="choseGift"
                />
              </div>
              <div v-if="!mode.Products">
                <BuyCarProductItem
                  v-for="(goodsItem, index) in item.GoodsSkus"
                  v-if="mode.Id.includes(goodsItem.ProductSKUId)"
                  :key="goodsItem.ProductSKUId"
                  style="margin-top: 20px;"
                  :item="goodsItem"
                  :index="index"
                  :is-zq-activity="true"
                  :has-margin-top="hasMarginTopChange(goodsItem)"
                  :is-always-buys-com="isAlwaysBuysCom"
                  :activity-gift-list="ordinaryGoodsPremiumList"
                  :total-amount="totalAmount"
                  @changeGroupActiveGift="changeGroupActiveGift"
                  @itemCheckedChanged="checkedChange"
                  @onStepperChange="onStepperChange"
                />
              </div>
            </div>
          </template>
        </template>

      </div>
      <!-- /商品列表 -->
    </div>

    <!-- 空购物车 -->
    <div
      v-if="!goodsList.length && !invalidGoods.length"
      :class="{ emptycar: true, isAlwaysBuysCom: isAlwaysBuysCom }"
    >
      <img src="../../assets/buycar/empty.png">
      <div class="ecar-txt">暂无数据~</div>
      <van-button
        color="#0F6EEA"
        :to="{ path: '/' }"
        style="margin-top: 30px;"
      >去首页逛逛</van-button>
    </div>
    <iRightFixedBox v-if="!isAlwaysBuysCom" />
    <iFooter v-if="!isAlwaysBuysCom" />

  </div>
</template>

<script>
import iHeader from '@/components/Header'
import iFooter from '@/components/Footer'
import iRightFixedBox from '@/components/RightFixedBox'
import BuyCarProductItem from '@/components/BuyCarProductItem'
import { LinkTypeCode } from '@/dictionary/base.js'
import { BaseMixin } from '../../mixins/BaseMixin'
import BuyCarGiftItem from './subCom/BuyCarGiftItem.vue'
import BuyCarTopicActiveTag from '@/views/buyCar/subCom/BuyCarTopicActiveTag.vue'
import ActiveTagNotice from '@/components/ActiveTagNotice'
import BuyCarGiftItemActivity from './subCom/BuyCarGiftItemActivity.vue'
export default {
  components: {
    iHeader,
    BuyCarProductItem,
    iFooter,
    iRightFixedBox,
    BuyCarTopicActiveTag,
    BuyCarGiftItem,
    BuyCarGiftItemActivity,
    ActiveTagNotice
  },
  mixins: [BaseMixin],
  props: {
    isAlwaysBuysCom: {
      // 是否为近期未采购页
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      LinkTypeCode,
      // list
      allGoodsList: [], // 所有商品
      goodsList: [], // 购物车商品
      rebateCouponsList: [], // 返券列表
      ordinaryGoodsPremiumList: [], // 平台满赠活动列表
      invalidGoods: [], // 失效商品

      contentHeight: '700px',

      showInputNum: false,
      valInputNum: 0,
      valItem: {},
      /**
       * 数据加载的相关状态
       */
      stepChanging: false,
      formData: {
        page: 0,
        pagesize: 100
      },
      checkedAll: false, // 是否全选
      totalChooseNum: 0, // 已选择商品数
      totalAllNum: 0, // 购物车有效商品总数
      totalAmount: 0, // 已选中商品总价
      totalProfit: 0, // 总毛利

      LogisticsFee: {},

      PromotionList: {
        Reduction: [], // 买减，满减
        Present: [], // 买赠，满赠
        Coupons: [] // 返券
      },
      url: {
        // 常购清单
        getPurchasedList: '/api_order/ShoppingCarts/GetPurchasedGoods',
        // 获取购物车商品列表
        cardGoodsList: '/api_order/ShoppingCarts/GetNewShoppingCartsList',
        // 满赠信息
        activityPremiumZon:
          '/api_order/ShoppingCarts/GetShoppingCartActivityList',
        // 商品步长
        addOrUpdateCart: '/api_order/ShoppingCarts/AddOrUpdateCart',
        // 移除购物车信息
        delete: '/api_order/ShoppingCarts/Delete',
        // 购物车所有活动列表
        promotionList: '/api_order/ShoppingCarts/GetOrderPromotionList',
        // 购物车返券查询
        rebateCouponsList: '/api_coupon/Coupon/ShoppingCartsCoupons',
        // 获取物流费用的接口
        logisticsFee: '/api_order/Orders/LogisticsTemplate',
        // 结算创建订单
        confirmCarOrder: '/api_order/Orders/ConfirmOrderV2'
      },
      // 赠品列表
      GiftInfo: {
        OverScopeList: [],
        GiftList: []
      },
      // 满赠-按照订单
      GroupByOrder: false,
      // 满赠-按照订单列表
      GroupByOrderList: [],
      // 按订单-显示所有阶梯
      AllConfig: null,
      // 多商品满赠配置集合
      MoreActivGift: [],
      // 多商品模块赠品集合
      GroupActiveGift: [],
      // 满赠-类型为每满的倍数
      Multiple: 0,
      // 安商品 满赠-类型为多商品
      MultipleMore: 0,
      // 安订单 满赠-类型为每满的倍数
      GroupByOrderMultiple: 0,
      // 提交封装满赠活动数据
      SubmitActivitys: [],
      ModelList: [],
      // 购物中所有商品赠品（判断） 集合
      GifthasSendList: [],
      // 按订单可选商品数量
      GroupByOrderChooseGiftNum: 0,
      // 按订单判断是否选送选完
      gifthasSend: {},
      GroupByOrderFianll: false,
      // 判断是否有赠品
      IsHasGift: false
    }
  },
  computed: {
    // 过滤失效商品
    getFailGoodsList() {
      const { goodsList } = this
      // 降维获取所有购物车商品
      const allCarGoodsList = goodsList.map((item) => item.GoodsSkus).flat()
      const filterFailList = allCarGoodsList.filter(
        (item) => !item.IsPutaway || item.Stock <= 0
      )
      return filterFailList
    },
    // 获取是否满足包邮
    getPinkage() {
      const { LogisticsFee, totalAmount } = this
      if (
        LogisticsFee.StartingPrice <= totalAmount &&
        LogisticsFee.FreePostagePrice > totalAmount
      ) {
        return true
      }
      return false
    }
  },
  watch: {
    goodsList: {
      // 商品数据源变动时，重新计算价格相关
      // 商品数据源变动时，判断全选与反选的关系
      handler(val) {
        if (val.length > 0) {
          this.calcMoney()
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    const cusInfo = this.$auth.getCustomerOtherInfo()
    if (!cusInfo || !cusInfo.IsOrder) {
      this.$toast({
        position: 'bottom',
        message:
          cusInfo && cusInfo.NoOrderMsg ? cusInfo.NoOrderMsg : '暂时不能下单'
      })
      this.$router.push(LinkTypeCode.Home)
      return
    }
  },
  mounted() {
    this.onRefresh()
  },
  methods: {
    // 单商品不满足活动消除参数
    canclSubmitActivitys(ActivityId) {
      this.SubmitActivitys = this.SubmitActivitys.filter(
        (oo) => oo.ActivityId != ActivityId
      )
    },
    // 单商品的提交参数
    onlySubmitActivitys(SubmitActivitys) {
      this.SubmitActivitys.map((oo) => {
        if (oo.ActivityId == SubmitActivitys[0].ActivityId) {
          oo.FreebieIds = SubmitActivitys[0].FreebieIds
          oo.GoodIds = SubmitActivitys[0].GoodIds
        }
      })
      if (
        this.SubmitActivitys.filter(
          (oo) => oo.ActivityId == SubmitActivitys[0].ActivityId
        ).length == 0
      ) {
        this.SubmitActivitys.push(...SubmitActivitys)
      }
    },
    // 活动内部有变化-调整活动的配置
    changeGroupActiveGift(val) {
      // 判断是哪一个多商品满赠活动
      this.goodsList.map((oo) => {
        oo.GoodsSkus.map((tt) => {
          if (tt.ProductSKUId == val) {
            this.getMoreActivGift(oo, val)
          }
        })
      })
    },
    // 同步从专区赠品传递的数据
    syncSubmitActivitysFromActivity({ GiftList, dataSource }) {
      const { Activity, GoodsSkus } = dataSource
      const { Id: ActivityId } = Activity
      const index = this.SubmitActivitys.findIndex((val) => val.ActivityId == ActivityId)
      // 如果传递过来的giftlist为空，则需要在SubmitActivitys删除掉已存在的数据
      if (!GiftList.length) {
        if (index >= 0) {
          this.SubmitActivitys.splice(index, 1)
        }
      } else {
        const tempData = {
          ActivityId,
          FreebieIds: GiftList.map(val => val.GoodsSkuId),
          GoodIds: GoodsSkus.map(val => val.ProductSKUId)
        }
        // 直接构造覆盖数据
        if (index >= 0) {
          this.SubmitActivitys.splice(index, 1, tempData)
        } else {
          this.SubmitActivitys.push(tempData)
        }
      }
    },
    // 查看多商品满赠
    getMoreActivGift(item, ProductSKUId) {
      if (
        item.GoodsSkus.length > 0 &&
        this.ordinaryGoodsPremiumList.length > 0
      ) {
        const goodsIdList = []
        let activeTotalAmount = 0
        let activeTotalNum = 0
        const arrAmount = []
        const arrNum = []
        // 一个商品只能参加一个多商品满赠活动
        // 当前商品输在多商品满赠活动
        let activeObj = {}
        this.ordinaryGoodsPremiumList.map((oo) => {
          if (oo.GoodsSkuIds.includes(ProductSKUId) && oo.IsMulticommodity) {
            activeObj = oo
          }
        })
        // 新建一个当前商品所在活动的空集合
        const activeObjList = []
        if (activeObj.GoodsSkuIds) {
          activeObj.GoodsSkuIds.map((tt) => {
            item.GoodsSkus.map((oo) => {
              if (tt == oo.ProductSKUId) {
                activeObjList.push(oo)
              }
            })
          })
        }
        // 把当前商品所在活动的 所有 总数和价格计算
        activeObjList.map((b) => {
          arrAmount.push(b.PriceLimit * b.Count)
          arrNum.push(b.Count)
        })
        // 计算命中活动单个商品购买总价格 、总数 -start
        const activeAmount = Math.max.apply(Math, arrAmount)
        const activeNum = Math.max.apply(Math, arrNum)
        console.log('最大金额:' + activeAmount)
        console.log('最大购买数量:' + activeNum)
        // 计算命中活动单个商品购买总价格 、总数-end
        activeObjList.map((oo) => {
          // 计算命中活动所有个商品购买总价格 、总数 -start
          activeTotalAmount = activeTotalAmount + oo.PriceLimit * oo.Count
          activeTotalNum = activeTotalNum + oo.Count
          // 计算命中活动所有商品购买总价格 、总数-end
          goodsIdList.push(oo.ProductSKUId)
        })
        this.ordinaryGoodsPremiumList.map((oo) => {
          if (oo.IsMulticommodity) {
            let flag = true
            const ConditionType = oo.ConditionType
            goodsIdList.map((tt) => {
              if (!oo.GoodsSkuIds.includes(tt)) {
                flag = false
              }
            })
            // 判断是哪一个活动
            if (flag) {
              // 判断是属于那个阶梯配置
              let userMeetConfig = null
              let lastCondition = 0
              // 判断是活动内 所有商品总价、单个商品满赠
              // DiscountConditionType  单个 ：1  全部 ：2
              if (oo.DiscountConditionType == 1) {
                oo.Configs.forEach((tt) => {
                  if (tt.ConditionValueType == 3) {
                    if (
                      activeNum >= tt.Condition &&
                      tt.Condition >= lastCondition
                    ) {
                      lastCondition = tt.Condition
                      userMeetConfig = tt
                    }
                  } else {
                    if (
                      activeAmount >= tt.Condition &&
                      tt.Condition >= lastCondition
                    ) {
                      lastCondition = tt.Condition
                      userMeetConfig = tt
                    }
                  }
                })
              } else {
                oo.Configs.forEach((tt) => {
                  if (tt.ConditionValueType == 3) {
                    if (
                      activeTotalNum >= tt.Condition &&
                      tt.Condition >= lastCondition
                    ) {
                      lastCondition = tt.Condition
                      userMeetConfig = tt
                    }
                  } else {
                    if (
                      activeTotalAmount >= tt.Condition &&
                      tt.Condition >= lastCondition
                    ) {
                      lastCondition = tt.Condition
                      userMeetConfig = tt
                    }
                  }
                })
              }

              if (userMeetConfig) {
                // 封装要提交的满赠活动数据 -start
                // 赠品集合
                const FreebieIds = []
                let isAllMustSend = true
                userMeetConfig.ActivityConfigPresent.map((jj) => {
                  if (jj.checked || jj.IsMustSend) {
                    FreebieIds.push(jj.GoodsSkuId)
                  }
                  if (!jj.IsMustSend) {
                    isAllMustSend = false
                  }
                  // FreebieIds.push(jj.GoodsSkuId)
                  // 商品集合
                })
                const GoodIds = []
                GoodIds.push(ProductSKUId)
                if (
                  this.SubmitActivitys.filter(
                    (item) => item.ActivityId == oo.Id
                  ).length > 0
                ) {
                  this.SubmitActivitys.map((l) => {
                    if (l.ActivityId == oo.Id) {
                      l.GoodIds.push(ProductSKUId)
                      l.GoodIds = Array.from(new Set(l.GoodIds))
                      l.FreebieIds =
                        isAllMustSend &&
                        userMeetConfig.ActivityConfigPresent.length > 0
                          ? FreebieIds
                          : []
                    }
                  })
                } else {
                  this.SubmitActivitys.push({
                    ActivityId: oo.Id,
                    FreebieIds:
                      isAllMustSend &&
                      userMeetConfig.ActivityConfigPresent.length > 0
                        ? FreebieIds
                        : [],
                    GoodIds: GoodIds
                  })
                }
                // // 商品集合
                // let GoodIds = []
                // GoodIds.push(ProductSKUId)
                // if (this.SubmitActivitys.filter(item => item.ActivityId == oo.Id).length > 0) {
                //     this.SubmitActivitys.map(l => {
                //         if (l.ActivityId == oo.Id) {
                //             l.GoodIds.push(ProductSKUId)
                //             l.GoodIds = Array.from(new Set(l.GoodIds))
                //         }
                //     })
                // }
                // else {
                //     this.SubmitActivitys.push(
                //         {
                //             ActivityId: oo.Id,
                //             FreebieIds: [],
                //             GoodIds: GoodIds
                //         }
                //     )
                // }
                // 封装要提交的满赠活动数据 -end

                // 计算单个商品后买的每满倍数 ConditionValueType 1金额 3数量
                // ConditionType：1 满赠 2 每满
                if (userMeetConfig.ConditionValueType == 3) {
                  if (ConditionType == 1) {
                    // 判断如果是满赠
                    this.ModelList.map((tt) => {
                      if (tt.Products && tt.Products.includes(ProductSKUId)) {
                        tt.MultipleMore = 0
                        tt.ChooseGiftNum = userMeetConfig.ChooseGiftNum
                        tt.ActivityId = oo.Id
                      }
                    })
                    console.log(
                      '数量-满赠-多商品-满' + userMeetConfig.Condition
                    )
                  } else {
                    // 判断如果是每满，需要送几倍赠品
                    this.ModelList.map((tt) => {
                      if (tt.Products && tt.Products.includes(ProductSKUId)) {
                        tt.MultipleMore = parseInt(
                          activeTotalNum / userMeetConfig.Condition
                        )
                        tt.ChooseGiftNum = userMeetConfig.ChooseGiftNum
                        tt.ActivityId = oo.Id
                      }
                    })
                    // this.MultipleMore = parseInt(activeTotalNum / (userMeetConfig.Condition))
                    console.log(
                      '数量-每满-多商品-满' +
                        userMeetConfig.Condition +
                        '-送赠品倍数：' +
                        this.MultipleMore
                    )
                  }
                } else {
                  if (ConditionType == 1) {
                    // 判断如果是满赠
                    // this.MultipleMore = 0
                    this.ModelList.map((tt) => {
                      if (tt.Products && tt.Products.includes(ProductSKUId)) {
                        tt.MultipleMore = 0
                        tt.ChooseGiftNum = userMeetConfig.ChooseGiftNum
                        tt.ActivityId = oo.Id
                      }
                    })
                    console.log(
                      '金额-满赠-多商品-满' + userMeetConfig.Condition
                    )
                  } else {
                    // 判断如果是每满，需要送几倍赠品
                    this.ModelList.map((tt) => {
                      if (tt.Products && tt.Products.includes(ProductSKUId)) {
                        tt.MultipleMore = parseInt(
                          activeTotalAmount / userMeetConfig.Condition
                        )
                        tt.ChooseGiftNum = userMeetConfig.ChooseGiftNum
                        tt.ActivityId = oo.Id
                      }
                    })
                    // this.MultipleMore = parseInt(activeTotalAmount / (userMeetConfig.Condition))
                    console.log(
                      '金额-每满-多商品-满' +
                        userMeetConfig.Condition +
                        '-送赠品倍数：' +
                        this.MultipleMore
                    )
                  }
                }
                // 返回对应的配置阶梯赠品集合
                this.ModelList.map((tt) => {
                  if (tt.Products && tt.Products.includes(ProductSKUId)) {
                    tt.GroupActiveGift = userMeetConfig
                      ? userMeetConfig.ActivityConfigPresent
                      : null
                    tt.ChooseGiftNum = userMeetConfig.ChooseGiftNum
                    tt.ActivityId = oo.Id
                  }
                })
              } else {
                this.canclSubmitActivitys(oo.Id)
                this.ModelList.map((tt) => {
                  if (tt.Products && tt.Products.includes(ProductSKUId)) {
                    tt.GroupActiveGift = []
                    tt.ChooseGiftNum = userMeetConfig
                      ? userMeetConfig.ChooseGiftNum
                      : 0
                    tt.ActivityId = oo.Id
                  }
                })
              }
            }
          }
        })
      }
    },
    // 判断到底是满赠多商品还是单商品-样式控制
    hasMarginTopChange(item) {
      // console.log(item.OperationName ? item.OperationName : item.SkuName)
      let flag = true
      // 判断是否在多商品中又有单商品满赠
      let isOnlyOne = true
      // 获取所有满赠活动（单商品、多商品）
      this.ordinaryGoodsPremiumList.map((oo) => {
        // 判断是否是按商品满赠
        if (oo.ConfigType == 1) {
          // 判断是否在多商品满赠里面
          if (
            oo.GoodsSkuIds.includes(item.ProductSKUId) > 0 &&
            oo.IsMulticommodity
          ) {
            isOnlyOne = false
            flag = false
          }
          // 判断是否在单商品满赠中
          else if (
            oo.GoodsSkuIds.includes(item.ProductSKUId) > 0 &&
            !oo.IsMulticommodity
          ) {
            // 判断是否已在多商品满赠中了
            if (!isOnlyOne) {
              flag = false
            } else {
              flag = true
            }
          }
        }
      })
      return flag
    },
    // 按订单-选择满赠阶梯
    choseGiftList(list) {
      this.AllConfig = list
      let userMeetConfig = null
      let lastCondition = 0
      list[0].Configs.forEach((tt) => {
        if (this.totalAmount >= tt.Condition && tt.Condition >= lastCondition) {
          lastCondition = tt.Condition
          userMeetConfig = tt
        }
      })
      // 判断如果是每满，需要送几倍赠品 ConditionType：1 满赠 2 每满
      if (
        this.GroupByOrderList[0] &&
        this.GroupByOrderList[0].ConditionType == 2
      ) {
        // 按金额
        if (this.GroupByOrderList[0].Configs[0].ConditionValueType == 1) {
          if (userMeetConfig) {
            this.GroupByOrderMultiple = parseInt(
              this.totalAmount / userMeetConfig.Condition
            )
            console.log(
              '每满-金额-按订单-满' +
                userMeetConfig.Condition +
                '-送赠品倍数：' +
                this.GroupByOrderMultiple
            )
          }
        } else {
          // 按数量
          this.GroupByOrderMultiple = parseInt(
            this.totalChooseNum / userMeetConfig.Condition
          )
          console.log(
            '每满-数量-按订单-满' +
              userMeetConfig.Condition +
              '-送赠品倍数：' +
              this.GroupByOrderMultiple
          )
        }
      } else {
        console.log('满赠-金额-按订单')
      }
      if (userMeetConfig) {
        this.GroupByOrderChooseGiftNum = userMeetConfig.ChooseGiftNum
        this.GiftInfo.GiftList = userMeetConfig.ActivityConfigPresent
        let flag = true
        userMeetConfig.ActivityConfigPresent.map((oo) => {
          if (oo.IsMustSend == false) {
            flag = false
          }
        })
        if (flag) {
          const FreebieIds = []
          userMeetConfig.ActivityConfigPresent.map((oo) => {
            FreebieIds.push(oo.GoodsSkuId)
          })
          if (
            this.SubmitActivitys.filter((tt) => tt.ActivityId == list[0].Id)
              .length > 0
          ) {
            this.SubmitActivitys.map((oo) => {
              if (oo.ActivityId == list[0].Id) {
                oo.FreebieIds = FreebieIds
              }
            })
          } else {
            this.SubmitActivitys.push({
              ActivityId: this.GroupByOrderList[0].Id,
              FreebieIds: FreebieIds,
              GoodIds: []
            })
          }
          this.GroupByOrderFianll = true
        }
      }
      return userMeetConfig ? userMeetConfig.ActivityConfigPresent : null
    },

    // 点击选择赠品-点击确定按钮回调
    surenext(val) {
      if (val.isByOrderOver) {
        this.GroupByOrderFianll = true
      }
      const flag = false
      if (
        this.SubmitActivitys.filter((tt) => tt.ActivityId == val.ActivityId)
          .length > 0
      ) {
        this.SubmitActivitys.map((oo) => {
          if (oo.ActivityId == val.ActivityId) {
            oo.FreebieIds = val.List
          }
        })
      } else {
        if (val.isByOrderOver) {
          // 订单满赠
          if (
            this.SubmitActivitys.filter((tt) => {
              tt.ActivityId == this.GroupByOrderList[0].Id
            }).length > 0
          ) {
            this.SubmitActivitys.map((ll) => {
              if (ll.ActivityId == this.GroupByOrderList[0].Id) {
                ll.FreebieIds = val.List
              }
            })
          } else {
            this.SubmitActivitys.push({
              ActivityId: this.GroupByOrderList[0].Id,
              FreebieIds: val.List,
              GoodIds: []
            })
          }
        } else {
          this.activityPremiumList.map((oo) => {
            if (oo.Id == val.ActivityId) {
              this.SubmitActivitys.push({
                ActivityId: val.ActivityId,
                FreebieIds: val.List,
                GoodIds: oo.GoodsSkuIds
              })
            }
          })
        }
      }
      this.$refs.GiftDaigItem.show = false
    },
    // 点击选择赠品按钮
    choseGift(val) {
      this.$refs.GiftDaigItem.type = 'chose'
      this.$refs.GiftDaigItem.show = true
      this.$refs.GiftDaigItem.isByOrder = val.isByOrder
      this.$refs.GiftDaigItem.Multiple = val.Multiple
      this.GiftInfo.ChooseGiftNum = val.ChooseGiftNum
      this.GiftInfo.GiftList = val.GiftList
      this.GiftInfo.ActivityId = val.ActivityId
    },
    // 凑单跳转
    goSearch() {
      this.$router.push({
        name: LinkTypeCode.SearchPage,
        query: {}
      })
    },
    // 计算选中商品总价、毛利、总数相关
    calcMoney() {
      let totalAmount = 0 // 选中商品总价
      let totalProfit = 0 // 总毛利
      let totalChooseNum = 0 // 选中商品总数
      let totalAllNum = 0 // 有效商品总盒数
      // 计算有效商品总数量
      // 有效商品集合
      const validList = this.goodsList
        .map((item) => item.GoodsSkus || [])
        .flat()
      validList.forEach((item) => {
        totalAllNum += item.Count
      })
      const chooseGoodsList = this.getAllChooseGoods()
      // 根据已选商品计算已选总毛利和已选数量
      const filterChooseList = [...new Set([...chooseGoodsList])]
      filterChooseList.forEach((item) => {
        totalProfit += (item.RetailPrice - item.PriceLimit) * item.Count
        totalChooseNum += item.Count
      })
      // 判断活动组商品和普通商品时计算总价
      this.goodsList.forEach((item) => {
        if (item.customGroupMoney) {
          // 活动组商品
          totalAmount += item.customGroupMoney
        } else {
          // 普通商品或非活动组商品
          item.GoodsSkus.forEach((childItem) => {
            if (childItem.checked) {
              const itemPrice = childItem.ActivityPrice ?? childItem.PriceLimit
              console.log(itemPrice * childItem.Count)
              totalAmount += ((itemPrice * 100) * childItem.Count) / 100
            }
          })
        }
      })
      this.totalAmount = totalAmount // 选中商品总价
      this.totalProfit = totalProfit // 总毛利
      this.totalChooseNum = totalChooseNum // 选中商品总数
      this.totalAllNum = totalAllNum
    },
    // 乱价投诉跳转
    price() {
      this.$router.push({
        path: LinkTypeCode.DisorderlyPrice
      })
    },
    // 全选与反选
    allCleckedClick() {
      const { checkedAll } = this
      if (checkedAll) {
        // 全选
        this.setAllGoodsItemCheckStatus(true)
      } else {
        // 取消全选
        this.setAllGoodsItemCheckStatus(false)
      }
    },
    // 设置所有商品选中状态
    setAllGoodsItemCheckStatus(checkedStatus) {
      // 设置有效商品的状态
      for (let i = 0; i < this.goodsList.length; i++) {
        const itemGoodsSkuList = this.goodsList[i].GoodsSkus || []
        for (let index = 0; index < itemGoodsSkuList.length; index++) {
          const goodsItem = itemGoodsSkuList[index]
          goodsItem.checked = checkedStatus
        }
      }
      // 设置失效商品的状态
      // this.invalidGoods = this.invalidGoods.map(item => ({
      // 	...item,
      // 	checked: checkedStatus
      // }));
    },
    getAllGoodsCheckedStatus() {
      // 降维获取所有购物车商品
      const allCarGoodsList = this.goodsList
        .map((item) => item.GoodsSkus)
        .flat()
      // 判断有效商品是否有未选中
      const isNoCheckedItem = allCarGoodsList.some(
        (item) => !item.checked && item.IsPutaway && item.Stock > 0
      )
      return isNoCheckedItem
    },
    checkedChange() {
      // 判断是否全选
      if (this.getAllGoodsCheckedStatus()) {
        this.checkedAll = false
        return
      }
      this.checkedAll = true
    },
    // 删除商品
    async removeCart(arrs) {
      let rst = []
      if (Array.isArray(arrs)) {
        rst = arrs.map((item) => item.Id)
      } else {
        rst = this.goodsList
          .filter((item) => item.checked)
          .map((newItem) => newItem.Id)
      }
      if (rst.length == 0) {
        this.$toast({
          position: 'bottom',
          message: '请先选择需要删除的商品'
        })
        return
      }
      this.$hys.openLoading()
      const res = await this.postAction(this.url.delete, rst)
      this.$hys.clearLoading()
      if (!res.IsSuccess) {
        this.$toast({ position: 'bottom', message: res.Msg })
        return
      }

      // 删除本地数据
      rst.forEach((tid) => {
        const index = this.goodsList.findIndex((w) => w.Id == tid)
        if (index > -1) {
          this.goodsList.splice(index, 1)
        }
      })

      this.$bus.$emit('rightBuycarChanged', res.Data.ProductCount, true)
      this.checkedAll = false
      // this.getBuyCarList();
    },

    getCouponName(item) {
      // 新用户
      if (item.IsGiftNewCustomer) {
        // return `新用户首单返${item.GiftNumber}张${item.TotalMoney}元商品券`;
        return `新用户首单返${item.TotalMoney}元优惠券`
      }
      // 限定订单金额
      if (item.LimitOrderPrice > 0) {
        // return `订单满${item.LimitOrderPrice}返${item.GiftNumber}张${item.TotalMoney}元商品券`;
        return `订单满${item.LimitOrderPrice}返${item.TotalMoney}元优惠券`
      }
      // 限定订单盒数
      if (item.OrderRequireNumber > 0) {
        // return `订单满${item.LimitOrderPrice}盒返${item.GiftNumber}张${item.TotalMoney}元商品券`;
        return `订单满${item.LimitOrderPrice}盒返${item.TotalMoney}元优惠券`
      }
    },
    /**
     * ajax部分
     */
    // 初始加载
    async onRefresh() {
      this.init()
      this.formData.page = 0 // 初始请求分页
      await this.onLoad()
    },
    async init() {
      Object.assign(this.$data, this.$options.data.call(this))

      const { isAlwaysBuysCom = false } = this
      // 获取物流满包邮信息
      this.getAction(this.url.logisticsFee).then((res) => {
        this.LogisticsFee = res.LogisticsTemplate || {}
      })
      if (!isAlwaysBuysCom) {
        // 购物车返券查询
        this.getAction(this.url.rebateCouponsList).then((res) => {
          if (!res.IsSuccess) {
            return
          }
          this.rebateCouponsList = res.Data
        })
      }
      this.getActivityPremiumZon() // 获取满赠活动
      this.SubmitActivitys = []
    },
    // 加载商品数据
    async onLoad() {
      this.formData.page = this.formData.page + 1
      await this.getBuyCarList()
    },

    // 加载购物车数据
    async getBuyCarList() {
      const { isAlwaysBuysCom = false } = this
      const { cardGoodsList, getPurchasedList } = this.url
      // 加载状态
      this.$hys.openLoading()
      const res = await this.getAction(
        `${isAlwaysBuysCom ? getPurchasedList : cardGoodsList}`,
        this.formData
      )
      this.$hys.clearLoading()
      if (!res.IsSuccess) {
        // 数据异常，停止继续加载数据
        this.$toast({ position: 'bottom', message: res.Msg })
        return
      }
      if (this.formData.page == 1) {
        this.goodsList = []
      }
      // 数据处理
      this.filterInvalidGoods(res.Data || [])
      this.checkedChange()
    },
    toAddCarCheckLimit(sendNum, startNum, step, limitNum) {
      try {
        if (!sendNum) {
          return startNum
        }
        if (!step && !limitNum) {
          return sendNum
        }
        if (!step && limitNum) {
          return limitNum
        }
        if (sendNum == startNum) {
          // 购买数等于起购数时
          return sendNum
        }
        if (limitNum && sendNum > limitNum) {
          // 输入大于限购时返回满足小于限购的，并符合步长规则的数值
          const no = Math.floor((limitNum * 1 - startNum * 1) / (step * 1))
          const rightNum = startNum + step * no
          return rightNum
        }
        return sendNum
      } catch (error) {
        console.log(error)
      }
    },
    // 步长加减购-
    async onStepperChange(Count, changeGoodsItem) {
      try {
        const { isAlwaysBuysCom = false } = this
        const { LimitPerOrder, PurchaseNumber, StepLengthNumber } =
          changeGoodsItem
        // if (this.stepChanging) {
        //     return false;
        // } else {
        // 注意通过async-change设置value时，vant会触发两次change方法，故做一次请求拦截判断
        if (isAlwaysBuysCom) {
          changeGoodsItem.Count = this.toAddCarCheckLimit(
            Count,
            PurchaseNumber,
            StepLengthNumber,
            LimitPerOrder
          )
          // console.log(Count);
          // 快速下单页时不进行购物车加购，只数据自身数量加减
          return false
        }
        if (
          changeGoodsItem.changeCount &&
          changeGoodsItem.changeCount === Count
        ) {
          return false
        }
        const toastLoading = this.$toast.loading({
          message: '',
          duration: 0,
          forbidClick: true
        })
        changeGoodsItem.disabled = true
        this.stepChanging = true
        const { ProductSKUId, SourceSkuId = '' } = changeGoodsItem
        // 步长请求
        const res = await this.postAction(this.url.addOrUpdateCart, {
          ProductSKUId,
          Count,
          SourceGoodsSkuId: SourceSkuId
        })
        console.log(res)
        // 判断是否可以加购
        if (res.Data.IsLimitPerOrder) {
          this.$toast({
            position: 'bottom',
            message:
              '单笔订单限购（' +
              changeGoodsItem.LimitPerOrder +
              '）' +
              changeGoodsItem.Unit
          })
          return false
        }
        if (!res.IsSuccess) {
          this.$toast({
            position: 'bottom',
            message: res.Msg
          })
          this.stepChanging = false
          changeGoodsItem.disabled = false
          return
        }
        // 判断是否超限
        if (res.Data.IsLimit === null || !res.Data.IsLimit) {
          changeGoodsItem.changeCount = Count
          if (changeGoodsItem.PriceLimit != res.Data.Price) { changeGoodsItem.PriceLimit = res.Data.Price }
          if (changeGoodsItem.Count != res.Data.Amount) { changeGoodsItem.Count = res.Data.Amount }
          changeGoodsItem.disabled = false
        }

        if (res.Data.CountData) {
          if (!isAlwaysBuysCom) {
            // 购物车页时
            this.$bus.$emit(
              'rightBuycarChanged',
              res.Data.CountData.ProductCount,
              true
            )
          }

          this.stepChanging = false
          toastLoading.clear()
        }
        // }
      } catch (error) {
        this.stepChanging = false
        changeGoodsItem.disabled = false
        console.log(error)
      }
    },
    // 获商品满赠活动和商品满赠信息
    async getActivityPremiumZon() {
      try {
        const res = await this.getAction(`${this.url.activityPremiumZon}`)
        if (res.IsSuccess) {
          // Type 3:满赠 2：专区 1：商城   ConfigType：1按商品 2 按订单
          // 过滤出需要展示到购物车顶部的满赠信息，包括普通商品平台的满赠活动、商城活动中不限商品的满赠活动、

          // 普通商品满赠活动
          const ordinaryGoodsPremiumListResult = res.Data.filter(
            (item) => item.Type === 3 && item.ConfigType !== 2
          )
          // 普通商品的满赠信息-用于在商品列表中匹配普通商品的满赠信息
          this.ordinaryGoodsPremiumList = ordinaryGoodsPremiumListResult
          // GroupByOrder：true 活动类型为满赠-按订单（购物车头部展示满赠）
          this.GroupByOrder =
            res.Data.filter((item) => item.Type === 3 && item.ConfigType == 2)
              .length > 0
          if (this.GroupByOrder) {
            const list = res.Data.filter(
              (item) => item.Type === 3 && item.ConfigType == 2
            )
            // 根据订单金额选择满赠配置中第几个config
            this.GroupByOrderList = list
            this.choseGiftList(this.GroupByOrderList)
          }
          // 商城订单满赠信息（适用于商城活动按订单配置-不限商品或客户未购进商品）(展示到商城顶部)

          res.Data ||
            [].filter(
              (item) =>
                item.Type != 3 &&
                (item.GoodsSelectScope === 1 || item.GoodsSelectScope === 3)
            )
          this.activityPremiumList = res.Data
          // console.log(orderPremiumList);
        }
      } catch (e) {
        console.log(e)
      }
    },

    // 获取选中商品的集合-默认只返回有效商品的集合，编辑时删除返回所有集合
    getAllChooseGoods(type = '') {
      // 有效商品集合
      const validList = this.goodsList
        .map((item) => item.GoodsSkus || [])
        .flat()
        .filter((item) => item.checked)
      if (type === 'all') {
        // 所有时返回有效和失效商品的id集合
        // 失效商品id集合
        const failList = this.invalidGoods.filter((item) => item.checked)
        return [...validList, ...failList]
      } else {
        return validList
      }
    },
    // 判断商品是否失效
    isFailGoods(goodsItem) {
      // GoodsType 1-专区 2-商城 3-普通
      const {
        IsOutBusinessScope,
        IsPutaway,
        Stock,
        GoodsType,
        IsActivityGoodsTimeOut,
        IsValid
      } = goodsItem
      // 商品0库存或者失效时展示商品状态
      if (!IsPutaway || Stock <= 0 || IsOutBusinessScope) {
        return true
      } else if (
        (GoodsType !== 3 && IsActivityGoodsTimeOut) ||
        (GoodsType !== 3 && !IsValid)
      ) {
        // 活动商品超时时也失效
        return true
      }
      return false
    },
    // 过滤商品
    /**
     * 失效商品规则：
     * 1、活动商品活动超时时 失效
     * 2、商品库存不足 - 失效
     * 3、商品已下架- 失效
     */
    filterInvalidGoods(carGoodsArr) {
      try {
        // const mockData = {
        //   ActivityPrice: 150,
        //   PriceLimit: 80,
        //   RetailPrice: 21,
        //   Logo: 'http://skupic.yaoyueyue.com/upload/2020/c3628fcd3c2d44f6914ccb490050b347_s.jpg'
        // }
        const allGoodsList = carGoodsArr
          .map((item) => item.GoodsSkus || [])
          .flat()
        //   valid
        const invalidGoods = []
        const filterGoods = []
        for (let index = 0; index < carGoodsArr.length; index++) {
          const { Activity } = carGoodsArr[index] // 活动信息
          const childGoodsList = carGoodsArr[index].GoodsSkus
          const newGoodsList = []
          childGoodsList.forEach((element) => {
            if (!this.isFailGoods(element)) {
              newGoodsList.push({
                ...element,
                disabled: false,
                checked: true,
                changeCount: element.Count
                // ...mockData,
              }) // 有效商品默认选中
            } else {
              // 失效产品
              invalidGoods.push({
                ...element,
                disabled: true,
                checked: false
                // ...mockData,
              }) // 失效商品禁用
            }
          })
          // 包含有效商品时再追加，否则商品都为失效
          if (newGoodsList.length) {
            if (Activity && Activity.ConfigType === 2) {
              filterGoods.push({
                Activity,
                GoodsSkus: newGoodsList,
                groupDisabled: false,
                groupChecked: true
              })
            } else {
              filterGoods.push({
                Activity,
                GoodsSkus: newGoodsList
              })
            }
          }
        }
        console.log('--->过滤掉的有效商品列表', filterGoods)
        console.log('--->失效商品', invalidGoods)
        this.goodsList = filterGoods
        // 修饰商品列表排序-同意多活动排在一起
        setTimeout(() => {
          this.changeGoodsList(filterGoods)
        }, 1000)

        this.invalidGoods = invalidGoods
        this.allGoodsList = allGoodsList
        // 初始时设置未全选中
        // this.checkedAll = true
      } catch (error) {
        console.log(error)
      }
    },
    // 购物车商品排列-分块问题
    changeGoodsList(list) {
      // 1.首先专区活动。商城活动商品排列在第一
      // 2.多商品活动排列在第二（同一商品活动商品排列在一起）
      // 3.单商品活动排列在第三
      const NewList = []
      // 1.首先专区活动。商城活动商品排列在第一
      list.map((tt) => {
        if (tt.Activity) {
          NewList.push(tt)
        }
      })
      // 2.多商品活动排列在第二（同意多商品活动，商品排列在一起）
      // 获取所有的普通满赠活动的商品
      const NoActiveProductList = []
      const NoActiveProductName = []
      let AllActiveProducIdList = []
      // 找出所有的满赠活动id数组
      if (this.ordinaryGoodsPremiumList.length > 0) {
        this.ordinaryGoodsPremiumList.map((oo) => {
          AllActiveProducIdList = [...AllActiveProducIdList, ...oo.GoodsSkuIds]
        })
        console.log('所有的满赠活动商品id' + AllActiveProducIdList)
        list.map((oo) => {
          // 判断满赠的商品
          if (!oo.Activity) {
            // 循环满赠活动列表
            this.ordinaryGoodsPremiumList.map((ll) => {
              // // 全部的满赠活动商品
              oo.GoodsSkus.map((tt) => {
                if (
                  ll.GoodsSkuIds.includes(tt.ProductSKUId) &&
                  ll.IsMulticommodity
                ) {
                  // 多商品满赠
                  const flag = this.ModelList.filter((item) => item.Id == ll.Id)
                  if (flag.length == 0) {
                    this.ModelList.push({
                      Id: ll.Id,
                      Products: [tt.ProductSKUId],
                      GroupActiveGift: [],
                      MultipleMore: 0
                    })
                  } else {
                    this.ModelList.map((item) => {
                      if (item.Id == ll.Id) {
                        item.Products.push(tt.ProductSKUId)
                      }
                    })
                  }
                  NoActiveProductList.push(tt)
                  NoActiveProductName.push(
                    tt.OperationName ? tt.OperationName : tt.SkuName
                  )
                } else if (
                  ll.GoodsSkuIds.includes(tt.ProductSKUId) &&
                  !ll.IsMulticommodity
                ) {
                  if (
                    this.ordinaryGoodsPremiumList.filter((l) =>
                      l.GoodsSkuIds.includes(tt.ProductSKUId)
                    ).length == 1
                  ) {
                    // 单商品满赠
                    const flag = this.ModelList.filter((item) => item.Id == ll.Id)
                    if (flag.length == 0) {
                      this.ModelList.push({
                        Id: ll.Id,
                        Products: [tt.ProductSKUId],
                        GroupActiveGift: [],
                        MultipleMore: 0
                      })
                    }
                    NoActiveProductList.unshift(tt)
                    NoActiveProductName.unshift(
                      tt.OperationName ? tt.OperationName : tt.SkuName
                    )
                  }
                } else if (!AllActiveProducIdList.includes(tt.ProductSKUId)) {
                  const flag = this.ModelList.filter(
                    (item) => item.Id == tt.ProductSKUId
                  )
                  if (flag.length == 0) {
                    this.ModelList.push({ Id: tt.ProductSKUId })
                  }
                  // 没有满赠
                  NoActiveProductList.unshift(tt)
                  NoActiveProductName.unshift(
                    tt.OperationName ? tt.OperationName : tt.SkuName
                  )
                }
              })
            })
            oo.GoodsSkus = Array.from(new Set(NoActiveProductList))
          }
        })
        console.log(
          '排序后的商品列表：' +
            JSON.stringify(Array.from(new Set(NoActiveProductName)))
        )
      } else {
        // 除了满赠其他的商品都在这里展示
        this.goodsList.map((tt) => {
          tt.GoodsSkus.map((oo) => {
            this.ModelList.push({
              Id: oo.ProductSKUId,
              Products: [oo.ProductSKUId],
              GroupActiveGift: [],
              MultipleMore: 0,
              isNomal: true
            })
          })
        })
      }
    },
    // 判断活动的选送赠品是否选择了
    checkgifthasSend(val) {
      // 判断是否已有这个活动选送信息
      if (
        this.GifthasSendList.filter((oo) => oo.ActivId == val.ActivId).length >
        0
      ) {
        this.GifthasSendList.map((oo) => {
          if (oo.ActivId == val.ActivId) {
            oo.Num = val.Num
          }
        })
      } else {
        this.GifthasSendList.push(val)
      }
    },
    // 提交判断选增是否选择完了
    checkedSend() {
      let flag = true
      this.SubmitActivitys.map((oo) => {
        this.GifthasSendList.map((tt) => {
          if (tt.ActivId == oo.ActivityId) {
            if (tt.Num != oo.FreebieIds.length) {
              flag = false
            }
          }
        })
      })
      return flag
    },
    async isHasGift() {
      if (this.SubmitActivitys.length > 0) {
        let goodsIds = []
        this.SubmitActivitys.map((oo) => {
          goodsIds = [...goodsIds, ...oo.FreebieIds]
        })
        const res = await this.postAction(
          '/api_order/ShoppingCarts/GetGoodSkuIsExistence',
          {
            goodsIds: goodsIds
          }
        )
        if (res.Data) {
          this.IsHasGift = true
        }
        return false
      }
    }

  }
}
</script>

<style scoped lang="less">
@import url('./src/styles/BuyCar.less');

/deep/.notify_class {
  /deep/.el-message-box__message p {
    color: red;
  }
}

</style>
